/* unplugin-vue-components disabled */import { render } from "./initiate.vue?vue&type=template&id=edf32dde"
import script from "./initiate.vue?vue&type=script&lang=js"
export * from "./initiate.vue?vue&type=script&lang=js"

import "./initiate.vue?vue&type=style&index=0&id=edf32dde&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__